import type { IconNode } from '../types';

/**
 * @name strawberry
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTcgNyAzLjUtMy41IiAvPgogIDxwYXRoIGQ9Ik0xNyAydjVoNSIgLz4KICA8cGF0aCBkPSJNMi4xIDE3LjFhNCA0IDAgMCAwIDQuOCA0LjhsOS0yLjFhNi4zMiA2LjMyIDAgMCAwIDIuOS0xMC45TDE1IDUuMkE2LjUgNi41IDAgMCAwIDQuMSA4LjNaIiAvPgogIDxwYXRoIGQ9Ik04LjUgOS41aC4wMSIgLz4KICA8cGF0aCBkPSJNMTIuNSA4LjVoLjAxIiAvPgogIDxwYXRoIGQ9Ik03LjUgMTMuNWguMDEiIC8+CiAgPHBhdGggZD0iTTExLjUgMTIuNWguMDEiIC8+CiAgPHBhdGggZD0iTTE1LjUgMTEuNWguMDEiIC8+CiAgPHBhdGggZD0iTTYuNSAxNy41aC4wMSIgLz4KICA8cGF0aCBkPSJNMTAuNSAxNi41aC4wMSIgLz4KICA8cGF0aCBkPSJNMTQuNSAxNS41aC4wMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/strawberry
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const strawberry: IconNode = [
  ['path', { d: 'm17 7 3.5-3.5', key: 'o60thn' }],
  ['path', { d: 'M17 2v5h5', key: '4pfb6l' }],
  [
    'path',
    {
      d: 'M2.1 17.1a4 4 0 0 0 4.8 4.8l9-2.1a6.32 6.32 0 0 0 2.9-10.9L15 5.2A6.5 6.5 0 0 0 4.1 8.3Z',
      key: 'p7gs',
    },
  ],
  ['path', { d: 'M8.5 9.5h.01', key: '1wuler' }],
  ['path', { d: 'M12.5 8.5h.01', key: 'ekt4gb' }],
  ['path', { d: 'M7.5 13.5h.01', key: 'nw9rut' }],
  ['path', { d: 'M11.5 12.5h.01', key: '1ijv9s' }],
  ['path', { d: 'M15.5 11.5h.01', key: '15hbig' }],
  ['path', { d: 'M6.5 17.5h.01', key: 'tpch40' }],
  ['path', { d: 'M10.5 16.5h.01', key: '3ihp3q' }],
  ['path', { d: 'M14.5 15.5h.01', key: '1y3nld' }],
];

export default strawberry;
